<template>
  <span v-if="!rights.includes('hide_patient_phone')">
    <a v-if="outgoingCallThrough === 'standard'"
       :href="`tel:${phone}`">
      {{ formatPhone(phone) }}
    </a>
    <a v-else
       @click="makeCall"
       class="pointer"
       :class="`text-${color}`">
      {{ formatPhone(phone) }}
    </a>
  </span>
</template>

<script>

import { mapState } from "vuex"
import { makeCall } from "@/services/call.service"
import {formatPhone} from "@/extensions/filters/filters"

export default {
  name: "OutgoingCallElement",
  props: {
    phone: {
      required: true
    },
    color: {
      type: String,
      default: 'primary'
    }
  },
  computed: {
    ...mapState({
      clinic: state => state.auth.clinic,
      rights: state => state.auth.rights,
    }),
    outgoingCallThrough() {
      return this.clinic?.clinic_additional?.outgoing_calls || 'standard'
    },
  },
  methods: {
    formatPhone,
    async makeCall() {
      const res = await makeCall(this.clinic, this.phone)
      if(res?.data) {
        this.$noty.info(this.$t('success_message'))
      } else {
        this.$noty.error(this.$t('error_message'))
      }
    }
  }
}
</script>
